import { Pipe, PipeTransform } from '@angular/core';
import { EnumListItem } from '../../../models/ui.model';

@Pipe({
    name: 'enumToArray',
})
export class EnumToArrayPipe implements PipeTransform {
    //Array to set the enum that contain the following string to the last position
    toLastArrayList = ['Others', 'Other', 'IHaveNotTakenAnyTest'];

    transform(data: EnumData, sortAsc?: boolean): EnumListItem[] {
        const keys: EnumListItem[] = [];

        for (const enumMember in data) {
            if (data[enumMember] && typeof data[enumMember] === 'string') {
                keys.push({ id: parseInt(enumMember), value: data[enumMember.toString()] as string });
            }
        }

        if (sortAsc)
            keys.sort((a, b) => {
                if (a.value > b.value) {
                    return 1;
                } else if (a.value < b.value) {
                    return -1;
                } else {
                    return 0;
                }
            });

        const toMoveToLast: EnumListItem[] = [];

        this.toLastArrayList.forEach((lastItem) => {
            const index = keys.findIndex((x) => x.value === lastItem);

            if (index !== -1) {
                toMoveToLast.push(...keys.splice(index, 1));
            }
        });

        return keys.concat(toMoveToLast);
    }
}

interface EnumData {
    [key: number | string]: string | number;
}
